// "use strict"; (function () { HTMLElement.prototype.matchHeight = function (settings) { return new MatchHeight(this, settings) }; function MatchHeight(wrapEl, settings) { this.wrapEl = wrapEl; let default_settings = { elements: null, byRow: true, target: null, attributeName: null, attributeValue: null, property: "height", remove: null, events: true, throttle: 80 }; this.settings = Object.assign(Object.assign({}, default_settings), settings); if (!this._validateProperty(this.settings.property)) { this.settings.property = "height" } if (this.settings.events) { var $this = this; this._bind = function () { $this._applyAll($this) }; if (document.readyState !== "loading") { this._bind() } else { document.addEventListener("DOMContentLoaded", this._bind, { once: true }) } if (this.settings.throttle && this.settings.throttle > 0) this._bind = this._throttle(this._bind, this.settings.throttle); this._init() } } MatchHeight.prototype._init = function () { window.addEventListener("resize", this._bind); window.addEventListener("orientationchange", this._bind) }; MatchHeight.prototype._unbind = function () { window.removeEventListener("resize", this._bind); window.removeEventListener("orientationchange", this._bind) }; MatchHeight.prototype._merge = function (o1, o2) { if (o1 != null) { for (var i in o1) { o2[i] = o1[i] } } return o2 }; MatchHeight.prototype._throttle = function (fn, threshold) { let last, deferTimer; return function () { const now = Date.now(); if (last && now < last + threshold) { clearTimeout(deferTimer); deferTimer = setTimeout(function () { last = now; fn() }, threshold) } else { last = now; fn() } } }; MatchHeight.prototype._applyAll = function ($this) { if ($this == null) { $this = this } $this._apply(); if ($this.settings.attributeName && $this._validateProperty($this.settings.attributeName)) { $this._applyDataApi($this.settings.attributeName) } $this._applyDataApi("data-match-height"); $this._applyDataApi("data-mh") }; MatchHeight.prototype._validateProperty = function (value) { return String(value).toLowerCase().match(/^([a-z-]{2,})$/) }; MatchHeight.prototype._parse = function (value) { return parseFloat(value) || 0 }; MatchHeight.prototype._rows = function (elements) { var $this = this; var tolerance = 1, lastTop = -1, listRows = [], rows = []; elements.forEach($that => { var top = $that.getBoundingClientRect().top - $this._parse(window.getComputedStyle($that).getPropertyValue("margin-top")); if (lastTop != -1 && Math.floor(Math.abs(lastTop - top)) >= tolerance) { listRows.push(rows); rows = []; lastTop = -1 } rows.push($that); lastTop = top }); listRows.push(rows); return listRows }; MatchHeight.prototype._applyDataApi = function (property) { var $this = this; var $row = Array.from(this.wrapEl.querySelectorAll("[" + property + "]")); $row.forEach($el => { var groupId = $el.getAttribute(property); $this.settings = $this._merge({ attributeName: property, attributeValue: groupId }, $this.settings); $this._apply() }) }; MatchHeight.prototype._remove = function () { var $elements = []; var opts = this.settings; if (opts.elements) { $elements = Array.from(this.wrapEl.querySelectorAll(opts.elements)) } else { if (opts.attributeName && opts.attributeValue) { $elements = Array.from(this.wrapEl.querySelectorAll("[" + opts.attributeName + '="' + opts.attributeValue + '"]')) } } $elements.forEach(item => { item.style.setProperty(opts.property, ""); if (item.getAttribute("style") === "") item.removeAttribute("style") }) }; MatchHeight.prototype._apply = function () { var $this = this; var opts = $this.settings; var $elements = []; if (opts.elements && opts.elements.trim() != "") { $elements = Array.from(this.wrapEl.querySelectorAll(opts.elements)) } else { if (opts.attributeName && $this._validateProperty(opts.attributeName) && opts.attributeValue && opts.attributeValue.trim() != "") { $elements = Array.from(this.wrapEl.querySelectorAll("[" + opts.attributeName + '="' + opts.attributeValue + '"]')) } } var rows = [$elements]; if (opts.byRow && !opts.target) { $elements.forEach($that => { var display = window.getComputedStyle($that).getPropertyValue("display"); if (display && (display !== "inline-block" && display !== "flex" && display !== "inline-flex")) { display = "display: block; " } $that.setAttribute("style-cache", $that.getAttribute("style") || ""); $that.setAttribute("style", display + "padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; border-top-width: 0; border-bottom-width: 0; height: 100px; overflow: hidden;") }); rows = this._rows($elements); $elements.forEach($that => { $that.setAttribute("style", $that.getAttribute("style-cache") || ""); $that.removeAttribute("style-cache"); if ($that.getAttribute("style") === "") $that.removeAttribute("style") }) } rows.forEach($row => { var targetHeight = 0; if (!opts.target) { if (opts.byRow && $row.length <= 1) { $row.forEach($that => { $this._resetStyle($that, opts.property) }); return } $row.forEach($that => { var style = $that.getAttribute("style") || "", display = window.getComputedStyle($that).getPropertyValue("display"); if (display && (display !== "inline-block" && display !== "flex" && display !== "inline-flex")) { display = "block" } $that.setAttribute("style", "display: " + display + ";"); var isTarget = true; if (opts.remove) { if (opts.remove instanceof NodeList) { opts.remove.forEach($el => { if ($that === $el) { isTarget = false } }) } else { if ($that === opts.remove) { isTarget = false } } } if (isTarget) { if ($that.getBoundingClientRect().height > targetHeight) { targetHeight = $that.getBoundingClientRect().height } } if (style) { $that.setAttribute("style", style) } else { $that.style.setProperty("display", "") } if ($that.getAttribute("style") === "") $that.removeAttribute("style") }) } else { targetHeight = opts.target.getBoundingClientRect().height } $row.forEach($that => { var verticalPadding = 0; if (opts.target && $that === opts.target) { return } verticalPadding = $this._parse(window.getComputedStyle($that).getPropertyValue("padding-top")) + $this._parse(window.getComputedStyle($that).getPropertyValue("padding-bottom")) + $this._parse(window.getComputedStyle($that).getPropertyValue("border-top-width")) + $this._parse(window.getComputedStyle($that).getPropertyValue("border-bottom-width")); $that.style.setProperty(opts.property, targetHeight - verticalPadding + "px"); if ($that.getBoundingClientRect().height < targetHeight) { $that.style.setProperty(opts.property, targetHeight + "px") } if (opts.remove) { if (opts.remove instanceof NodeList) { var removedItems = Array.from(opts.remove); removedItems.forEach($el => { if ($that === $el) { $this._resetStyle($el, opts.property) } }) } else { if ($that === opts.remove) { $this._resetStyle($that, opts.property) } } } }) }) }; MatchHeight.prototype._resetStyle = function ($that, property) { if (this._validateProperty(property)) { $that.style.setProperty(property, ""); if ($that.getAttribute("style") === "") $that.removeAttribute("style") } } })();


document.addEventListener('DOMContentLoaded', function () {

  //header JS
  var announce_country = document.querySelector('.announcement-bar .disclosure-form button.disclosure__toggle--currency');
  var announce_list = document.querySelector('.announcement-bar .disclosure-form ul.disclosure-list');
  if (announce_country) {
    announce_country.addEventListener('click', function () {
      const ariaExpanded = announce_country.getAttribute("aria-expanded") === "true";

      if (ariaExpanded) {
        // hideList();
        announce_country.setAttribute("aria-expanded", false);
        announce_list.setAttribute("aria-hidden", true);
      } else {
        // showList();
        announce_country.setAttribute("aria-expanded", true);
        announce_list.setAttribute("aria-hidden", false);
        announce_list.classList.add('disclosure-list--right');
      }
    });
  }


  document.addEventListener("click", handleBodyClick);

  function handleBodyClick(evt) {
    const toggle = document.querySelector('.announcement-bar .disclosure-form button.disclosure__toggle--currency'); // Assuming the element with aria-expanded is the toggle
    const ariaExpanded = toggle.getAttribute("aria-expanded") === "true"; // Check if the dropdown is open
    var announce_list = document.querySelector('.announcement-bar .disclosure-form ul.disclosure-list');

    // Check if the click is within the dropdown or its toggle
    const isOption = toggle.contains(evt.target) || announce_list.contains(evt.target);

    if (ariaExpanded && !isOption) { // If the dropdown is open and the click is outside
      // hideList(); // Close the dropdown
      announce_country.setAttribute("aria-expanded", false);
      announce_list.setAttribute("aria-hidden", true);
    }
  }

  /*-- Match Height --*/
  /*
  setTimeout(function(){
    document.body.matchHeight({elements: '.product-item__product-title'});
  },1000);
  */

  //open countries hide header drawer button
  document.querySelectorAll('a.drawer-menu__link[data-item="viewCurrency"]').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('button.header__icon-menu').classList.add('hide');
    });
  });

  //close countries show header button
  document.querySelectorAll('.drawer-menu__list--country-selector .drawer-menu__item--heading-back-link').forEach(function (element) {
    element.addEventListener('click', function () {
      document.querySelector('button.header__icon-menu').classList.remove('hide');
    });
  });

  /**
   * 初始化产品变体图片切换功能
   */
  document.querySelectorAll('.product-item .product-item__variant-info ul li').forEach(function (variantItem) {
    variantItem.addEventListener('click', function () {
      var var_img_url = this.getAttribute('data-var-url');

      if (var_img_url) {
        // Find the closest .product-item element
        var productItem = this.closest('.product-item');

        if (productItem) {
          // Remove 'active' class from all variant items
          productItem.querySelectorAll('.product-item__variant-info ul li').forEach(function (item) {
            item.classList.remove('active');
          });

          // Add 'active' class to clicked item
          this.classList.add('active');

          // Find the main product image element
          var imageElement = productItem.querySelector('.product-item__media .product-item__image--one img');

          // Find the second image element (if exists)
          var imageElement_2 = productItem.querySelector('.product-item__media .product-item__image--two');

          // Update main image
          if (imageElement) {
            imageElement.removeAttribute('srcset');
            imageElement.setAttribute('src', var_img_url);
          }

          // Hide second image if exists
          if (imageElement_2) {
            imageElement_2.classList.remove('active');
          }
        }
      }
    });
  });

  /**
   * 价格hover显示USD价格功能
   */
  function initPriceHoverTooltip() {
    // 扩展选择器以包含所有价格元素
    // 注意：购物车和迷你购物车中，只选择打折后的价格（.sale-price），原价不选择
    const priceSelectors = [
      '.product-item__price[data-price-cents]',
      '.product__price[data-price-cents]',
      '.sticky-atc-bar__price[data-price-cents]',
      '.cart__form-item-price.sale-price[data-price-cents]',
      '.quick-cart__item-price.sale-price[data-price-cents]',
      '.cart__total-price[data-price-cents]',
      '.quick-cart__total-price[data-price-cents]',
      '.product-price[data-price-cents]',
      '.cross-sells__item-price-wrapper[data-price-cents]'
    ].join(', ');
    
    const priceElements = document.querySelectorAll(priceSelectors);
    
    // 缓存汇率数据
    let currencyRates = null;
    let usdRate = null;
    
    // 获取货币汇率
    function fetchCurrencyRates() {
      return new Promise(function(resolve) {
        // 如果已经有汇率数据，直接返回
        if (currencyRates && usdRate) {
          resolve({ rates: currencyRates, usdRate: usdRate });
          return;
        }
        
        // 尝试从Shopify获取汇率
        if (window.Shopify && window.Shopify.currency) {
          // 方法1: 使用Shopify.currency.rate (当前货币相对于商店基础货币的汇率)
          if (window.Shopify.currency.rate) {
            const currentRate = window.Shopify.currency.rate;
            const activeCurrency = window.Shopify.currency.active || 'USD';
            const shopCurrency = window.Shopify.currency.shopCurrency || window.Shopify.currency.baseCurrency || 'USD';
            
            // 如果商店基础货币是USD
            if (shopCurrency === 'USD') {
              // Shopify的rate是：当前货币价格 = 基础货币价格 * rate
              // 所以：基础货币价格(USD) = 当前货币价格 / rate
              // 例如：如果SGD价格是100，rate是1.35，那么USD价格 = 100 / 1.35 = 74
              usdRate = currentRate; // rate就是转换系数，USD价格 = 当前价格 / rate
              resolve({ rates: null, usdRate: usdRate });
              return;
            } else {
              // 如果基础货币不是USD，需要先转换到基础货币，再转换到USD
              // 这里假设可以通过rates获取
              if (window.Shopify.currency.rates && window.Shopify.currency.rates.USD) {
                // rates.USD是基础货币到USD的汇率
                usdRate = currentRate * window.Shopify.currency.rates.USD;
                resolve({ rates: null, usdRate: usdRate });
                return;
              }
            }
          }
          
          // 方法2: 尝试从rates对象获取汇率
          if (window.Shopify.currency.rates) {
            currencyRates = window.Shopify.currency.rates;
            const activeCurrency = window.Shopify.currency.active || 'USD';
            const shopCurrency = window.Shopify.currency.shopCurrency || window.Shopify.currency.baseCurrency || 'USD';
            
            if (shopCurrency === 'USD' && currencyRates[activeCurrency]) {
              // rates[activeCurrency]是activeCurrency相对于USD的汇率
              usdRate = currencyRates[activeCurrency];
            } else if (currencyRates.USD) {
              // 如果基础货币不是USD，需要计算
              if (window.Shopify.currency.rate) {
                usdRate = window.Shopify.currency.rate * currencyRates.USD;
              } else {
                usdRate = currencyRates.USD;
              }
            }
            
            if (usdRate) {
              resolve({ rates: currencyRates, usdRate: usdRate });
              return;
            }
          }
        }
        
        // 方法3: 尝试通过API获取currencies.js
        fetch('/services/javascripts/currencies.js')
          .then(function(response) {
            if (response.ok) {
              return response.text();
            }
            throw new Error('Failed to fetch currencies');
          })
          .then(function(text) {
            // 解析currencies.js文件
            try {
              // 尝试匹配Shopify.currency.rates对象
              const ratesMatch = text.match(/Shopify\.currency\.rates\s*=\s*({[^}]+})/);
              if (ratesMatch) {
                const ratesStr = ratesMatch[1];
                // 安全地解析JSON对象
                const ratesObj = JSON.parse(ratesStr.replace(/(\w+):/g, '"$1":'));
                currencyRates = ratesObj;
                
                const activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
                const shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.shopCurrency) || 
                                    (window.Shopify && window.Shopify.currency && window.Shopify.currency.baseCurrency) || 'USD';
                
                if (shopCurrency === 'USD' && ratesObj[activeCurrency]) {
                  // 如果基础货币是USD，rates[activeCurrency]就是activeCurrency到USD的汇率
                  usdRate = ratesObj[activeCurrency];
                } else if (ratesObj.USD && window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
                  // 如果基础货币不是USD，需要结合rate计算
                  usdRate = window.Shopify.currency.rate * ratesObj.USD;
                }
              }
            } catch (e) {
              // 如果解析失败，尝试其他方法
            }
            resolve({ rates: currencyRates, usdRate: usdRate });
          })
          .catch(function() {
            // 如果所有方法都失败，返回null
            resolve({ rates: null, usdRate: null });
          });
      });
    }
    
    priceElements.forEach(function(priceEl) {
      // 标记已初始化，避免重复初始化
      if (priceEl.hasAttribute('data-tooltip-initialized')) {
        return;
      }
      priceEl.setAttribute('data-tooltip-initialized', 'true');
      
      const priceCents = parseInt(priceEl.getAttribute('data-price-cents')) || 0;
      const currentCurrency = priceEl.getAttribute('data-current-currency') || 'USD';
      const shopCurrency = priceEl.getAttribute('data-shop-currency') || 'USD';
      
      // 如果当前货币已经是USD，不需要显示tooltip
      if (currentCurrency === 'USD') {
        return;
      }
      
      // 创建tooltip元素
      const tooltip = document.createElement('div');
      tooltip.className = 'price-usd-tooltip';
      tooltip.style.display = 'none';
      document.body.appendChild(tooltip);
      
      let tooltipUsdRate = null;
      let isTooltipVisible = false;
      
      // 检测是否为移动端设备
      function isMobileDevice() {
        return window.innerWidth <= 768 || ('ontouchstart' in window || navigator.maxTouchPoints > 0);
      }
      
      // 获取USD价格的函数
      function getUSDPrice() {
        if (!tooltipUsdRate) {
          return null;
        }
        
        // 计算USD价格
        // tooltipUsdRate是当前货币到USD的汇率
        // 如果rate > 1，说明当前货币价值低于USD（如SGD），需要除以rate
        // 如果rate < 1，说明当前货币价值高于USD，需要除以rate
        const usdPriceCents = Math.round(priceCents / tooltipUsdRate);
        return usdPriceCents;
      }
      
      // 格式化价格为USD格式
      function formatUSDPrice(cents) {
        if (!cents) return '';
        const dollars = (cents / 100).toFixed(2);
        return '$' + dollars + ' USD';
      }
      
      // 显示tooltip
      function showTooltip(e) {
        if (!tooltipUsdRate) {
          // 如果还没有汇率，尝试获取
          fetchCurrencyRates().then(function(data) {
            if (data.usdRate) {
              tooltipUsdRate = data.usdRate;
              updateTooltip();
              isTooltipVisible = true;
            }
          });
          return;
        }
        updateTooltip();
        isTooltipVisible = true;
      }
      
      function updateTooltip() {
        const usdPriceCents = getUSDPrice();
        if (!usdPriceCents) {
          return;
        }
        
        const usdPriceText = formatUSDPrice(usdPriceCents);
        tooltip.textContent = usdPriceText;
        tooltip.style.display = 'block';
        
        // 获取价格元素的位置
        const rect = priceEl.getBoundingClientRect();
        
        // 检查价格元素的类型
        const isProductItem = priceEl.closest('.product-item') !== null;
        const isCartItem = priceEl.classList.contains('cart__form-item-price') || priceEl.classList.contains('quick-cart__item-price');
        const isCartTotal = priceEl.classList.contains('cart__total-price') || priceEl.classList.contains('quick-cart__total-price');
        const isCompleteLook = priceEl.classList.contains('product-price');
        const isCrossSells = priceEl.classList.contains('cross-sells__item-price-wrapper');
        const isFeaturedProduct = priceEl.closest('.featured-product') !== null && priceEl.classList.contains('product__price');
        const isStickyAtcBar = priceEl.classList.contains('sticky-atc-bar__price');
        
        // 计算tooltip位置
        let left, top;
        
        if (isProductItem) {
          // 列表页：tooltip显示在价格文本的上方，左对齐到价格文本的开始位置
          // 找到实际显示价格的元素（优先查找.sale，然后是包含价格的span）
          let priceTextEl = priceEl.querySelector('.sale');
          
          // 如果没有.sale，查找包含价格的span（排除visually-hidden）
          if (!priceTextEl || priceTextEl.textContent.trim() === '') {
            const spans = priceEl.querySelectorAll('span:not(.visually-hidden)');
            for (let i = 0; i < spans.length; i++) {
              const span = spans[i];
              // 检查span是否包含价格文本（包含$或数字）
              if (span.textContent.match(/[\$0-9]/)) {
                priceTextEl = span;
                break;
              }
            }
          }
          
          // 如果还是找不到，使用整个价格元素
          if (!priceTextEl) {
            priceTextEl = priceEl;
          }
          
          const priceTextRect = priceTextEl.getBoundingClientRect();
          
          // 使用价格文本元素的左边界，向右偏移7px（从15px调整为7px，向左移8px）
          left = priceTextRect.left + 7;
          
          // 在价格文本上方，留出足够空间
          top = rect.top - 38;
          
          // 添加列表页特定的类名
          tooltip.classList.add('price-usd-tooltip--listing');
        } else if (isCrossSells) {
          // Cross Sells：tooltip显示在打折后的价格（.sale）上方
          let salePriceEl = priceEl.querySelector('.sale');
          
          // 如果没有.sale，查找包含价格的元素
          if (!salePriceEl || salePriceEl.textContent.trim() === '') {
            salePriceEl = priceEl.querySelector('.cross-sells__item-price') || priceEl.querySelector('span:not(.visually-hidden)');
          }
          
          // 如果还是找不到，使用整个价格元素
          if (!salePriceEl) {
            salePriceEl = priceEl;
          }
          
          const salePriceRect = salePriceEl.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          
          // 对齐到打折后价格的左边界，向右偏移7px
          left = salePriceRect.left + 7;
          top = salePriceRect.top - tooltipRect.height - 8;
          
          // 添加列表页类名以使用左对齐样式
          tooltip.classList.add('price-usd-tooltip--listing');
        } else if (isFeaturedProduct) {
          // Featured Product (Get Them Before They're Gone)：tooltip显示在打折后的价格（[data-price]）上方
          let salePriceEl = priceEl.querySelector('[data-price]');
          
          // 如果找不到[data-price]，查找包含价格的元素
          if (!salePriceEl || salePriceEl.textContent.trim() === '') {
            salePriceEl = priceEl.querySelector('span:not(.visually-hidden):not([data-compare-price])');
          }
          
          // 如果还是找不到，使用整个价格元素
          if (!salePriceEl) {
            salePriceEl = priceEl;
          }
          
          const salePriceRect = salePriceEl.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          
          // 对齐到打折后价格的左边界，向右偏移7px
          left = salePriceRect.left + 7;
          top = salePriceRect.top - tooltipRect.height - 8;
          
          // 添加列表页类名以使用左对齐样式
          tooltip.classList.add('price-usd-tooltip--listing');
        } else if (isStickyAtcBar) {
          // Sticky ATC Bar：tooltip显示在打折后的价格（[data-price]）上方
          let salePriceEl = priceEl.querySelector('[data-price]');
          
          // 如果找不到[data-price]，查找包含价格的元素
          if (!salePriceEl || salePriceEl.textContent.trim() === '') {
            salePriceEl = priceEl.querySelector('span:not(.visually-hidden):not([data-compare-price])');
          }
          
          // 如果还是找不到，使用整个价格元素
          if (!salePriceEl) {
            salePriceEl = priceEl;
          }
          
          const salePriceRect = salePriceEl.getBoundingClientRect();
          const tooltipRect = tooltip.getBoundingClientRect();
          
          // 对齐到打折后价格的左边界，向右偏移7px
          left = salePriceRect.left + 7;
          top = salePriceRect.top - tooltipRect.height - 8;
          
          // 添加列表页类名以使用左对齐样式
          tooltip.classList.add('price-usd-tooltip--listing');
        } else if (isCartItem || isCartTotal || isCompleteLook) {
          // 购物车、Complete The Look：tooltip显示在价格元素上方，左对齐
          const tooltipRect = tooltip.getBoundingClientRect();
          left = rect.left;
          top = rect.top - tooltipRect.height - 8;
          
          // 添加列表页类名以使用左对齐样式
          tooltip.classList.add('price-usd-tooltip--listing');
        } else {
          // 详情页：tooltip显示在价格元素上方居中
          const tooltipRect = tooltip.getBoundingClientRect();
          left = rect.left + (rect.width / 2);
          top = rect.top - tooltipRect.height - 8;
          
          // 移除列表页类名（如果有）
          tooltip.classList.remove('price-usd-tooltip--listing');
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
      }
      
      // 隐藏tooltip
      function hideTooltip() {
        tooltip.style.display = 'none';
        isTooltipVisible = false;
      }
      
      // 切换tooltip显示/隐藏（用于移动端点击）
      function toggleTooltip(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        
        if (isTooltipVisible) {
          hideTooltip();
        } else {
          showTooltip(e);
          isTooltipVisible = true;
        }
      }
      
      // 预加载汇率
      fetchCurrencyRates().then(function(data) {
        if (data.usdRate) {
          tooltipUsdRate = data.usdRate;
        }
      });
      
      // 绑定事件
      const isMobile = isMobileDevice();
      
      if (isMobile) {
        // 移动端：使用点击事件
        priceEl.style.cursor = 'pointer';
        priceEl.addEventListener('click', function(e) {
          e.stopPropagation();
          toggleTooltip(e);
        });
      } else {
        // 桌面端：使用hover事件
        priceEl.addEventListener('mouseenter', showTooltip);
        priceEl.addEventListener('mouseleave', hideTooltip);
        priceEl.addEventListener('mousemove', function(e) {
          if (tooltip.style.display === 'block') {
            const rect = priceEl.getBoundingClientRect();
            const isProductItem = priceEl.closest('.product-item') !== null;
            
            let left, top;
            
            const isCartItem = priceEl.classList.contains('cart__form-item-price') || priceEl.classList.contains('quick-cart__item-price');
            const isCartTotal = priceEl.classList.contains('cart__total-price') || priceEl.classList.contains('quick-cart__total-price');
            const isCompleteLook = priceEl.classList.contains('product-price');
            const isCrossSells = priceEl.classList.contains('cross-sells__item-price-wrapper');
            const isFeaturedProduct = priceEl.closest('.featured-product') !== null && priceEl.classList.contains('product__price');
            const isStickyAtcBar = priceEl.classList.contains('sticky-atc-bar__price');
            
            if (isProductItem) {
              // 列表页：跟随价格文本位置
              let priceTextEl = priceEl.querySelector('.sale');
              
              if (!priceTextEl || priceTextEl.textContent.trim() === '') {
                const spans = priceEl.querySelectorAll('span:not(.visually-hidden)');
                for (let i = 0; i < spans.length; i++) {
                  const span = spans[i];
                  if (span.textContent.match(/[\$0-9]/)) {
                    priceTextEl = span;
                    break;
                  }
                }
              }
              
              if (!priceTextEl) {
                priceTextEl = priceEl;
              }
              
              const priceTextRect = priceTextEl.getBoundingClientRect();
              left = priceTextRect.left + 7;
              top = rect.top - 38;
            } else if (isCrossSells) {
              // Cross Sells：对齐到打折后的价格
              let salePriceEl = priceEl.querySelector('.sale');
              
              if (!salePriceEl || salePriceEl.textContent.trim() === '') {
                salePriceEl = priceEl.querySelector('.cross-sells__item-price') || priceEl.querySelector('span:not(.visually-hidden)');
              }
              
              if (!salePriceEl) {
                salePriceEl = priceEl;
              }
              
              const salePriceRect = salePriceEl.getBoundingClientRect();
              const tooltipRect = tooltip.getBoundingClientRect();
              left = salePriceRect.left + 7;
              top = salePriceRect.top - tooltipRect.height - 8;
            } else if (isFeaturedProduct) {
              // Featured Product：对齐到打折后的价格
              let salePriceEl = priceEl.querySelector('[data-price]');
              
              if (!salePriceEl || salePriceEl.textContent.trim() === '') {
                salePriceEl = priceEl.querySelector('span:not(.visually-hidden):not([data-compare-price])');
              }
              
              if (!salePriceEl) {
                salePriceEl = priceEl;
              }
              
              const salePriceRect = salePriceEl.getBoundingClientRect();
              const tooltipRect = tooltip.getBoundingClientRect();
              left = salePriceRect.left + 7;
              top = salePriceRect.top - tooltipRect.height - 8;
            } else if (isStickyAtcBar) {
              // Sticky ATC Bar：对齐到打折后的价格
              let salePriceEl = priceEl.querySelector('[data-price]');
              
              if (!salePriceEl || salePriceEl.textContent.trim() === '') {
                salePriceEl = priceEl.querySelector('span:not(.visually-hidden):not([data-compare-price])');
              }
              
              if (!salePriceEl) {
                salePriceEl = priceEl;
              }
              
              const salePriceRect = salePriceEl.getBoundingClientRect();
              const tooltipRect = tooltip.getBoundingClientRect();
              left = salePriceRect.left + 7;
              top = salePriceRect.top - tooltipRect.height - 8;
            } else if (isCartItem || isCartTotal || isCompleteLook) {
              // 购物车、Complete The Look：左对齐
              const tooltipRect = tooltip.getBoundingClientRect();
              left = rect.left;
              top = rect.top - tooltipRect.height - 8;
            } else {
              // 详情页：居中显示
              const tooltipRect = tooltip.getBoundingClientRect();
              left = rect.left + (rect.width / 2);
              top = rect.top - tooltipRect.height - 8;
            }
            
            tooltip.style.left = left + 'px';
            tooltip.style.top = top + 'px';
          }
        });
      }
    });
  }
  
  // 移动端：点击其他地方时隐藏所有tooltip（使用事件委托，只添加一次）
  let mobileClickHandlerAdded = false;
  let mobileScrollHandlerAdded = false;
  
  function addMobileClickHandler() {
    if (!mobileClickHandlerAdded) {
      document.addEventListener('click', function(e) {
        // 检查点击是否在价格元素或tooltip上
        const clickedPriceEl = e.target.closest('[data-price-cents]');
        const clickedTooltip = e.target.closest('.price-usd-tooltip');
        
        if (!clickedPriceEl && !clickedTooltip) {
          // 点击在其他地方，隐藏所有tooltip
          document.querySelectorAll('.price-usd-tooltip').forEach(function(tooltip) {
            tooltip.style.display = 'none';
          });
        }
      }, true); // 使用捕获阶段，确保在其他点击事件之前处理
      mobileClickHandlerAdded = true;
    }
  }
  
  // 移动端：全局滚动时隐藏所有tooltip（只添加一次）
  function addMobileScrollHandler() {
    if (!mobileScrollHandlerAdded) {
      function hideAllTooltipsOnScroll() {
        document.querySelectorAll('.price-usd-tooltip').forEach(function(tooltip) {
          tooltip.style.display = 'none';
        });
      }
      
      // 监听window滚动事件，隐藏所有tooltip
      window.addEventListener('scroll', hideAllTooltipsOnScroll, { passive: true });
      window.addEventListener('touchmove', hideAllTooltipsOnScroll, { passive: true });
      
      // 监听minicart滚动容器的滚动事件
      function setupQuickCartScrollHandler() {
        const quickCartForm = document.querySelector('.quick-cart__form');
        if (quickCartForm && !quickCartForm.hasAttribute('data-scroll-handler-added')) {
          quickCartForm.addEventListener('scroll', hideAllTooltipsOnScroll, { passive: true });
          quickCartForm.addEventListener('touchmove', hideAllTooltipsOnScroll, { passive: true });
          quickCartForm.setAttribute('data-scroll-handler-added', 'true');
        }
      }
      
      // 使用MutationObserver监听quick-cart的打开和内容变化
      const quickCartObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          // 检查quick-cart是否打开（添加了active类）
          const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
          if (quickCartWrapper && quickCartWrapper.classList.contains('active')) {
            // quick-cart打开时，设置滚动监听器
            setTimeout(setupQuickCartScrollHandler, 100);
          }
        });
      });
      
      // 监听quick-cart容器的变化
      const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
      if (quickCartWrapper) {
        quickCartObserver.observe(quickCartWrapper, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true
        });
      }
      
      // 监听quick-cart:open事件
      document.addEventListener('quick-cart:open', function() {
        setTimeout(setupQuickCartScrollHandler, 200);
      });
      
      // 初始设置
      setupQuickCartScrollHandler();
      
      // 延迟设置，确保DOM加载完成
      setTimeout(setupQuickCartScrollHandler, 500);
      
      mobileScrollHandlerAdded = true;
    }
  }
  
  // 初始化价格hover功能
  // 延迟执行以确保DOM完全加载
  setTimeout(function() {
    initPriceHoverTooltip();
    addMobileClickHandler();
    addMobileScrollHandler();
  }, 100);
  
  // 监听动态加载的内容（如AJAX加载的产品列表）
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        // 检查是否有新的价格元素被添加
        const newPriceSelectors = [
          '.product-item__price[data-price-cents]:not([data-tooltip-initialized])',
          '.product__price[data-price-cents]:not([data-tooltip-initialized])',
          '.sticky-atc-bar__price[data-price-cents]:not([data-tooltip-initialized])',
          '.cart__form-item-price.sale-price[data-price-cents]:not([data-tooltip-initialized])',
          '.quick-cart__item-price.sale-price[data-price-cents]:not([data-tooltip-initialized])',
          '.cart__total-price[data-price-cents]:not([data-tooltip-initialized])',
          '.quick-cart__total-price[data-price-cents]:not([data-tooltip-initialized])',
          '.product-price[data-price-cents]:not([data-tooltip-initialized])',
          '.cross-sells__item-price-wrapper[data-price-cents]:not([data-tooltip-initialized])'
        ].join(', ');
        
        const newPriceElements = document.querySelectorAll(newPriceSelectors);
        if (newPriceElements.length > 0) {
          setTimeout(function() {
            initPriceHoverTooltip();
          }, 100);
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});